import { palette } from "lib/miolo";
import IconCard, { CardDescription, CardValue } from "components/company/v2/cards/IconCard";
import { lightFormat } from "date-fns";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import parseDateYmd from "lib/utils/parseDateYmd";
import numeral from "numeral";

interface IIbovespaCardProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment;
}

export default function IbovespaCard({ issuer }: IIbovespaCardProps) {
  if (!issuer.b3IndexParticipation) {
    return null;
  }

  const icon = (
    <svg width={14} height={14} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (!issuer.marketCapitalization) {
    return null;
  }
  return (
    <div>
      <IconCard primaryColor={palette.stromboli} secondaryColor={palette.grannyApple} icon={icon}>
        <CardValue>
          {numeral(issuer.b3IndexParticipation.stockParticipationPercent).format("0.00").replace(".", ",")}%
        </CardValue>
        <CardDescription>
          Ibovespa • até {lightFormat(parseDateYmd(issuer.b3IndexParticipation.marketIndex.validUntil), "dd/MM/yyyy")}
        </CardDescription>
      </IconCard>
    </div>
  );
}
